var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.patientParticipant.latestScoreDefs)?_c('div',{staticClass:"report-score-acc-aha"},[_c('div',{staticClass:"acc-risk-value"},[_vm._v("\n        "+_vm._s(_vm.risk)+"\n    ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }